const doc = [({"da":({"js":({"merfoto":({"orders":({"order":"Ordrer"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;